function getGroupPathList(leafGroupPath) {
  const segmentList = (leafGroupPath ?? "").split("/").map((segment) => segment.trim()).filter(Boolean);
  return segmentList.map(
    (_, index) => segmentList.slice(0, index + 1).join("/")
  );
}
function getGroupName(groupPath) {
  const segmentList = groupPath.split("/");
  return segmentList[segmentList.length - 1] ?? "";
}
function getGroupCrumbList(leafGroupPath) {
  const groupPathList = getGroupPathList(leafGroupPath);
  const trailList = groupPathList.length > 1 ? groupPathList.slice(1) : groupPathList;
  return trailList.map((groupPath) => ({
    name: getGroupName(groupPath),
    groupPath
  }));
}
export {
  getGroupCrumbList,
  getGroupName,
  getGroupPathList
};
